import { GET_COUNTRIES } from './actionTypes';
import { getActionStatusName } from '@/store/helpers';


export const getInvitesStatus = state =>
  state.status[getActionStatusName(GET_COUNTRIES)] || {};
